/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountFeatureFlagsDropdownListParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
    order: zod.string().optional(),
});

export type ApiAccountFeatureFlagsDropdownListParams = zod.input<
    typeof ApiAccountFeatureFlagsDropdownListParams
>;
export type ApiAccountFeatureFlagsDropdownListParamsOutput = zod.output<
    typeof ApiAccountFeatureFlagsDropdownListParams
>;
